import BaseHead from "../templates/BaseHead";
import { getSubdomain } from "../../utils/getSubdomain";
import STUtils from "../../assets/styles/utility.module.scss";
import BoardDetail from "../organisms/board_detail";
import BottomNavigationBar from "../organisms/BottomNavigationBar";

const BoardDetailComponent = () => {
  const subdomain = getSubdomain(window.location.hostname);
  return (
    <BaseHead
      title="ボードの詳細"
      login={true}
      subdomain={subdomain}
      hasNavigationBar={true}
      hasBackButton={true}
    >
      <div className={STUtils.container_large}>
        <BoardDetail />
        <div style={{ marginBottom: "24px" }}>
          <BottomNavigationBar />
        </div>
      </div>
    </BaseHead>
  );
};

export default BoardDetailComponent;
